import { Component, input } from '@angular/core';
import { ERelatedPointAction } from 'src/app/project/components/related-points/related-points.consts';
import { iconMap } from 'src/app/project/shared/enums/icon-map';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TPushNotification } from '../../notification.model';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { IconModule } from 'src/app/project/components/icon/icon-module';

@Component({
  selector: 'pp-notification-relationship',
  templateUrl: './notification-relationship.component.html',
  styleUrls: ['../notification.component.scss', './notification-relationship.component.scss'],
  standalone: true,
  imports: [PipesModule, IconModule],
})
export class NotificationRelationshipComponent {
  ppNotification = input<TPushNotification>();

  EIconPath = EIconPath;
  ERelatedPointAction = ERelatedPointAction;
  iconMap = iconMap;
}
